const TIKTOK_PIXEL_ID = process.env.REACT_APP_TIKTOK_PIXEL_ID;

let initialized = false;

const injectTikTokPixel = () => {
  if (initialized || !TIKTOK_PIXEL_ID || document.getElementById('tiktok-pixel-script')) return;
  window.TiktokAnalyticsObject = 'ttq';
  const ttq = (window.ttq = window.ttq || []);
  ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie', 'holdConsent', 'revokeConsent', 'grantConsent'];
  ttq.setAndDefer = function (target, method) {
    target[method] = function () {
      target.push([method].concat(Array.prototype.slice.call(arguments, 0)));
    };
  };
  for (let i = 0; i < ttq.methods.length; i += 1) {
    ttq.setAndDefer(ttq, ttq.methods[i]);
  }
  ttq.instance = function (id) {
    const instance = ttq._i[id] || [];
    for (let i = 0; i < ttq.methods.length; i += 1) ttq.setAndDefer(instance, ttq.methods[i]);
    return instance;
  };
  ttq.load = function (id, config) {
    const url = 'https://analytics.tiktok.com/i18n/pixel/events.js';
    ttq._i = ttq._i || {};
    ttq._i[id] = [];
    ttq._i[id]._u = url;
    ttq._t = ttq._t || {};
    ttq._t[id] = +new Date();
    ttq._o = ttq._o || {};
    ttq._o[id] = config || {};
    const script = document.createElement('script');
    script.id = 'tiktok-pixel-script';
    script.type = 'text/javascript';
    script.async = true;
    script.src = `${url}?sdkid=${id}&lib=ttq`;
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(script, firstScript);
  };
  ttq.load(TIKTOK_PIXEL_ID);
  ttq.page();
  initialized = true;
};

export const syncTikTokConsent = (status) => {
  if (status === 'accepted') {
    injectTikTokPixel();
    if (window.ttq?.grantConsent) window.ttq.grantConsent();
    if (window.ttq?.enableCookie) window.ttq.enableCookie();
  }
  if (status === 'rejected' && window.ttq) {
    if (window.ttq.revokeConsent) window.ttq.revokeConsent();
    if (window.ttq.disableCookie) window.ttq.disableCookie();
  }
};

export const trackTikTokEvent = (eventName, payload = {}) => {
  if (!window.ttq) return;
  if (eventName === 'PageView') {
    window.ttq.page();
    return;
  }
  window.ttq.track(eventName, payload);
};
